/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

/**
 * Resolve the backend API base URL for the current browser context.
 *
 * In local dev, tenant subdomains (e.g. psag.pearlcrm.localhost) must call the API
 * on the same hostname so HttpOnly refresh cookies (SameSite=Lax) are sent on refresh.
 */
export const getApiBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL?.replace(/\/$/, '');
  if (configured) {
    return configured;
  }

  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  const protocol =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? 'https:'
      : 'http:';

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }

  // Tenant subdomains — API on same host, port 8000 (dev + typical prod).
  return `${protocol}//${hostname}:8000`;
};

/**
 * WebSocket base URL derived from the REST API URL (http→ws, https→wss).
 * Production frontends often sit on a different host than api.pearlcrm.com.au;
 * the socket must target the same host as axios, not window.location:8000.
 */
export const getWebSocketBaseUrl = () => {
  const apiUrl = getApiBaseUrl();
  try {
    const parsed = new URL(apiUrl);
    const wsProtocol = parsed.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${parsed.host}`;
  } catch {
    return 'ws://localhost:8000';
  }
};
